module.exports = __webpack_public_path__ + "static/media/12.10e5c4a8.jpg";